import { Modal, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import ReactCompareImage from "react-compare-image";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import Loader from "../Animations/Loader";
import { ICompareImages } from "./deck.gl.map";
import { env } from './../../env';
import Style from "./Map.module.css";
import {
	ZoomInOutlined, ZoomOutOutlined, DownloadOutlined, EditOutlined
} from '@ant-design/icons';
import { Button } from 'antd';
import UpdateEventForm from "./UpdateEventForm";
import { IEvent } from "../../interfaces/map.interfaces";
import UpdateSviEventForm from "./updateSviEventForm";
import {
	isTsouaUser,
	TSOUA_IMAGE_MODAL_ENLARGED_WIDTH,
	TSOUA_IMAGE_MODAL_WIDTH,
} from "../../constants/tsoua.constants";

const COMPACT_MODAL_WIDTH = "25%";
const COMPACT_MODAL_ENLARGED_WIDTH = "50%";

function useLandscapeDisplayUrl(src: string, enabled: boolean): string {
	const [displayUrl, setDisplayUrl] = useState(src);

	useEffect(() => {
		if (!src || !enabled) {
			setDisplayUrl(src);
			return;
		}

		let cancelled = false;
		let objectUrl: string | null = null;
		const img = new Image();
		img.crossOrigin = "anonymous";
		img.onload = () => {
			if (cancelled) return;
			if (img.naturalWidth >= img.naturalHeight) {
				setDisplayUrl(src);
				return;
			}

			const canvas = document.createElement("canvas");
			canvas.width = img.naturalHeight;
			canvas.height = img.naturalWidth;
			const ctx = canvas.getContext("2d");
			if (!ctx) {
				setDisplayUrl(src);
				return;
			}

			ctx.translate(canvas.width / 2, canvas.height / 2);
			ctx.rotate(Math.PI / 2);
			ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
			canvas.toBlob((blob) => {
				if (cancelled || !blob) {
					setDisplayUrl(src);
					return;
				}
				objectUrl = URL.createObjectURL(blob);
				setDisplayUrl(objectUrl);
			}, "image/png");
		};
		img.onerror = () => {
			if (!cancelled) setDisplayUrl(src);
		};
		img.src = src;

		return () => {
			cancelled = true;
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [src, enabled]);

	return displayUrl || src;
}

function CompareImages({
	images,
	closeModal,
	eventObject,
	refreshEvents,
	language
}: {
	images: ICompareImages;
	closeModal: Function;
	eventObject: IEvent;
	language: string,
	refreshEvents: Function;
}) {
	const appContext: IAppContext = useContext(AppContext);
	const currentUser = appContext?.services?.firebaseService?.auth?.currentUser;
	const isTsouaAccount = isTsouaUser(currentUser?.uid, currentUser?.email);
	const defaultModalSize = isTsouaAccount
		? TSOUA_IMAGE_MODAL_WIDTH
		: COMPACT_MODAL_WIDTH;
	const enlargedModalSize = isTsouaAccount
		? TSOUA_IMAGE_MODAL_ENLARGED_WIDTH
		: COMPACT_MODAL_ENLARGED_WIDTH;
	const shouldShowModal: boolean = !!images.eventAfter || !!images.eventBefore;
	const [tokenData, setTokenData] = useState({ forceRefresh: true, token: "" });
	const [modalSize, setModalSize] = useState(defaultModalSize)
	const [visible, setVisible] = useState<boolean>(false);
	const [sviImageList, setSviImageList] = useState([]);
	const [latestImage, setLatestImage] = useState();
	const [latestImageObject, setLatestImageObject] = useState();
	const [latestImageDate, setLatestImageDate] = useState();
	const [comaparableImageSvi, setComaprarableImageSvi] = useState();
	const [comaparableImageDate, setcomaprarableImageDate] = useState();
	const [pipelineImageList, setPipelineImageList] = useState([]);
	const [pipelineLatestImage, setpipelineLatestImage] = useState();
	const [pipelineLatestImageObject, setPipelineLatestImageObject] = useState();
	const [piepelineLatestImageDate, setPipelineLatestImageDate] = useState();
	const [comaparableImagePipeline, setComaprarableImagePipeline] = useState();
	const [comaparablePipelineImageDate, setPipelineComaprarableImageDate] = useState();


	
	useEffect(() => {
		currentUser
			?.getIdToken()
			.then((value) => setTokenData({ forceRefresh: false, token: value }));
	}, [currentUser]);

	useEffect(() => {
		if (shouldShowModal) {
			setModalSize(defaultModalSize);
		}
	}, [shouldShowModal, defaultModalSize]);

	let embeddedApp = appContext?.projects?.app === "svi"

	useEffect(() => {
		if (!eventObject?.properties?.locationId) return;

		if (embeddedApp) {
			getImages().then((images) => {
				if (!images || images.length === 0) return;

				const events = [...(images[0].events || [])].filter(
					(event) => event.properties.image !== ""
				);
				if (events.length === 0) return;

				const sortedEvents = [...events].sort(
					(a, b) => new Date(a.properties.date).getTime() - new Date(b.properties.date).getTime()
				);

				const currentUserId = appContext?.services?.firebaseService?.auth?.currentUser?.uid;
				const specialUserId = "ifaoGKl5RFcNSnNHcbQYA6wltUa2";

				const oldest = sortedEvents[0];
				const latest = sortedEvents[sortedEvents.length - 1];

				if (currentUserId === specialUserId) {
					setLatestImage(latest.properties.id);
					setLatestImageDate(latest.properties.date.slice(0, 10));
					setLatestImageObject(latest);
					setComaprarableImageSvi(oldest.properties.id);
					setcomaprarableImageDate(oldest.properties.date.slice(0, 10));
				} else {
					const previous = sortedEvents[sortedEvents.length - 2] || oldest;
					setLatestImage(latest.properties.id);
					setLatestImageDate(latest.properties.date.slice(0, 10));
					setLatestImageObject(latest);
					setComaprarableImageSvi(previous.properties.id);
					setcomaprarableImageDate(previous.properties.date.slice(0, 10));
				}
				setSviImageList(sortedEvents);
			}).catch(console.error);
		} else if (isTsouaAccount) {
			getPipelineImages().then((images) => {
				if (!images || images.length === 0) return;

				const events = [...(images[0].events || [])].filter(
					(event) => event.properties.image !== ""
				);
				if (events.length === 0) return;

				const sortedEvents = [...events].sort(
					(a, b) => new Date(a.properties.date).getTime() - new Date(b.properties.date).getTime()
				);

				const currentUserId = appContext?.services?.firebaseService?.auth?.currentUser?.uid;
				const specialUserId = "ifaoGKl5RFcNSnNHcbQYA6wltUa2";

				const oldest = sortedEvents[0];
				const latest = sortedEvents[sortedEvents.length - 1];

				if (currentUserId === specialUserId) {
					setpipelineLatestImage(latest.properties.id);
					setPipelineLatestImageDate(latest.properties.date.slice(0, 10));
					setPipelineLatestImageObject(latest);
					setComaprarableImagePipeline(oldest.properties.id);
					setPipelineComaprarableImageDate(oldest.properties.date.slice(0, 10));
				} else {
					const previous = sortedEvents[sortedEvents.length - 2] || oldest;
					setpipelineLatestImage(latest.properties.id);
					setPipelineLatestImageDate(latest.properties.date.slice(0, 10));
					setPipelineLatestImageObject(latest);
					setComaprarableImagePipeline(previous.properties.id);
					setPipelineComaprarableImageDate(previous.properties.date.slice(0, 10));
				}
				setPipelineImageList(sortedEvents);
			}).catch(console.error);
		}
	}, [embeddedApp, appContext, eventObject, isTsouaAccount]);

	function getImages() {
		const locationId = eventObject?.properties?.locationId;
		if (!locationId) {
			return Promise.resolve([]);
		}
		return appContext?.services.sviEventService.getMyData().then((data) => {
			let comparableEventsSVI = data.data.filter(event => event.id === locationId);
			return comparableEventsSVI;
		});
	}

	function getPipelineImages() {
		const locationId = eventObject?.properties?.locationId;
		if (!locationId) {
			return Promise.resolve([]);
		}
		return appContext?.services.eventService.getMyData().then((data) => {
			let comparableEventspipeline = data.data.filter(event => event.id === locationId);
			return comparableEventspipeline;
		});
	}

	function downloadPngFile(url, filename = 'image.png') {
		fetch(url)
			.then(response => response.blob())
			.then(blob => {
				const blobUrl = URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = blobUrl;
				a.download = filename + ".png";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(blobUrl);
			})
			.catch(console.error);
	}

	const serverUrl = `${env.REACT_APP_SERVER_URL}`;
	const pipelineLeftId = isTsouaAccount
		? comaparableImagePipeline
		: images.eventBefore?.id;
	const pipelineRightId = isTsouaAccount
		? pipelineLatestImage
		: images.eventAfter?.id;
	const pipelineLeftSrc = `${serverUrl}/image/retrieve?eventId=${pipelineLeftId}&token=${tokenData.token}`;
	const pipelineRightSrc = `${serverUrl}/image/retrieve?eventId=${pipelineRightId}&token=${tokenData.token}`;
	const pipelineLeftDisplaySrc = useLandscapeDisplayUrl(
		pipelineLeftSrc,
		isTsouaAccount && !!pipelineLeftId && !!tokenData.token
	);
	const pipelineRightDisplaySrc = useLandscapeDisplayUrl(
		pipelineRightSrc,
		isTsouaAccount && !!pipelineRightId && !!tokenData.token
	);
	const compareImageCss = isTsouaAccount
		? { height: "100%", width: "100%", objectFit: "contain" }
		: { height: "100%", width: "100%", objectFit: "fill" };

	if (!shouldShowModal) return null;

	return (
		<div>
			<Modal
				getContainer={"#root"}
				onCancel={() => { closeModal(); setModalSize(defaultModalSize); }}
				visible={shouldShowModal}
				footer={null}
				width={modalSize}
				wrapClassName={isTsouaAccount ? Style.landscapeImageModal : undefined}
				style={{
					top: 20,
					right: 20,
					margin: 0,
					position: "absolute",
				}}
			>
				{embeddedApp ? (
					<div style={{ textAlign: "center" }}>
						<div style={{ display: "flex", justifyContent: "center", gap: "25px", alignItems: "center", margin: "15px"}} >
							<Select
								placeholder="Before Image"
								value={comaparableImageSvi}
								onSelect={(value) => {
									const selected = sviImageList.find(i => i.properties.id === value);
									if (selected) {
										setComaprarableImageSvi(selected.properties.id);
										setcomaprarableImageDate(selected.properties.date.slice(0, 10));
									}
								}}
								style={{ width: 250 }}
							>
								{sviImageList.filter(i => i.properties.id !== latestImage).map(image => (
									<Select.Option key={image.properties.id} value={image.properties.id}>
										{image.properties.date.slice(0, 10)}
									</Select.Option>
								))}
							</Select>
							<Select
								placeholder="After Image"
								value={latestImage}
								onSelect={(value) => {
									const selected = sviImageList.find(i => i.properties.id === value);
									if (selected) {
										setLatestImage(selected.properties.id);
										setLatestImageDate(selected.properties.date.slice(0, 10));
										setLatestImageObject(selected);
									}
								}}
								style={{ width: 250 }}
							>
								{sviImageList.filter(i => i.properties.id !== comaparableImageSvi).map(image => (
									<Select.Option key={image.properties.id} value={image.properties.id}>
										{image.properties.date.slice(0, 10)}
									</Select.Option>
								))}
							</Select>
						</div>

						<ReactCompareImage
							leftImage={`${serverUrl}/image/retrieve?eventId=${comaparableImageSvi}&token=${tokenData.token}`}
							leftImageAlt="Before"
							leftImageLabel={comaparableImageDate}
							rightImage={`${serverUrl}/image/retrieve?eventId=${latestImage}&token=${tokenData.token}`}
							rightImageAlt="After"
							rightImageLabel={latestImageDate}
							skeleton={<Loader />}
							rightImageCss={{ height: "100%", width: "100%", objectFit: "fill" }}
							leftImageCss={{ height: "100%", width: "100%", objectFit: "fill" }}
							vertical={false}
							handleSize={images.sliderController ? 40 : null}
							sliderPositionPercentage={images.sliderController ? 0.5 : 0}
							sliderLineWidth={images.sliderController}
						/>

						<Button className={Style.enlargeCompareImage} onClick={() => setModalSize("50%")} disabled={modalSize === "50%"}><ZoomInOutlined /></Button>
						<Button className={Style.minmizeComapreImage} onClick={() => setModalSize("25%")} disabled={modalSize === "25%"}><ZoomOutOutlined /></Button>
						<Button className={Style.minmizeComapreImage} onClick={() => downloadPngFile(`${serverUrl}/image/retrieve?eventId=${comaparableImageSvi}&token=${tokenData.token}`, comaparableImageSvi)}><DownloadOutlined /> Before Image</Button>
						<Button className={Style.minmizeComapreImage} onClick={() => downloadPngFile(`${serverUrl}/image/retrieve?eventId=${latestImage}&token=${tokenData.token}`, latestImage)}><DownloadOutlined /> Recent Image</Button>
						<Button className={Style.minmizeComapreImage} onClick={() => setVisible(true)}><EditOutlined /></Button>
					</div>
				) : (
					<div style={{ textAlign: "center" }}>

						{isTsouaAccount ? 
						<div style={{ display: "flex", justifyContent: "center", gap: "8px", alignItems: "center", margin: "0 0 10px"}} >
							<Select
								placeholder="Before Image"
								value={comaparableImagePipeline}
								onSelect={(value) => {
									const selected = pipelineImageList.find(i => i.properties.id === value);
									if (selected) {
										setComaprarableImagePipeline(selected.properties.id);
										setPipelineComaprarableImageDate(selected.properties.date.slice(0, 10));
									}
								}}
								style={{ width: 200 }}
							>
								{pipelineImageList.filter(i => i.properties.id !== pipelineLatestImage).map(image => (
									<Select.Option key={image.properties.id} value={image.properties.id}>
										{image.properties.date.slice(0, 10)}
									</Select.Option>
								))}
							</Select>
							<Select
								placeholder="After Image"
								value={pipelineLatestImage}
								onSelect={(value) => {
									const selected = pipelineImageList.find(i => i.properties.id === value);
									if (selected) {
										setpipelineLatestImage(selected.properties.id);
										setPipelineLatestImageDate(selected.properties.date.slice(0, 10));
										setPipelineLatestImageObject(selected);
									}
								}}
								style={{ width: 200 }}
							>
								{pipelineImageList.filter(i => i.properties.id !== comaparableImagePipeline).map(image => (
									<Select.Option key={image.properties.id} value={image.properties.id}>
										{image.properties.date.slice(0, 10)}
									</Select.Option>
								))}
							</Select>
						</div> : null }

						<div className={isTsouaAccount ? Style.landscapeCompareImage : undefined}>
							<ReactCompareImage
								leftImage={pipelineLeftDisplaySrc}
								leftImageAlt="Before"
								leftImageLabel={isTsouaAccount ? comaparablePipelineImageDate : `${images.eventBefore?.date.slice(0, 10)}`}
								rightImage={pipelineRightDisplaySrc}
								rightImageAlt="After"
								rightImageLabel={isTsouaAccount ? piepelineLatestImageDate : `${images.eventAfter?.date.slice(0, 10)}`}
								skeleton={<Loader />}
								rightImageCss={compareImageCss}
								leftImageCss={compareImageCss}
								aspectRatio={isTsouaAccount ? "wider" : "taller"}
								vertical={false}
								handleSize={images.sliderController ? 40 : null}
								sliderPositionPercentage={images.sliderController ? 0.5 : 0}
								sliderLineWidth={images.sliderController}
							/>
						</div>
						<Button className={Style.enlargeCompareImage} onClick={() => setModalSize(enlargedModalSize)} disabled={modalSize === enlargedModalSize}><ZoomInOutlined /></Button>
						<Button className={Style.minmizeComapreImage} onClick={() => setModalSize(defaultModalSize)} disabled={modalSize === defaultModalSize}><ZoomOutOutlined /></Button>

						{isTsouaAccount ? (
							<>
								<Button
								className={Style.minmizeComapreImage}
								onClick={() =>
									downloadPngFile(
									`${serverUrl}/image/retrieve?eventId=${comaparableImagePipeline}&token=${tokenData.token}`,
									comaparableImagePipeline
									)
								}
								>
								<DownloadOutlined /> Before Image
								</Button>
								<Button
								className={Style.minmizeComapreImage}
								onClick={() =>
									downloadPngFile(
									`${serverUrl}/image/retrieve?eventId=${pipelineLatestImage}&token=${tokenData.token}`,
									pipelineLatestImage
									)
								}
								>
								<DownloadOutlined /> Recent Image
								</Button>
							</>
							) : (
							<>
								<Button
								className={Style.minmizeComapreImage}
								onClick={() =>
									downloadPngFile(
									`${serverUrl}/image/retrieve?eventId=${images.eventBefore?.id}&token=${tokenData.token}`,
									images.eventBefore?.id
									)
								}
								>
								<DownloadOutlined /> Before Image
								</Button>
								<Button
								className={Style.minmizeComapreImage}
								onClick={() =>
									downloadPngFile(
									`${serverUrl}/image/retrieve?eventId=${images.eventAfter?.id}&token=${tokenData.token}`,
									images.eventAfter?.id
									)
								}
								>
								<DownloadOutlined /> Recent Image
								</Button>
							</>
							)}

						<Button className={Style.minmizeComapreImage} onClick={() => setVisible(true)}><EditOutlined /></Button>
					</div>
					
				)}
			</Modal>

			{embeddedApp ? (
				<UpdateSviEventForm
					event={eventObject as IEvent}
					visible={visible}
					setVisible={setVisible}
					latestImageObject={latestImageObject}
					refreshEvents={refreshEvents}
				/>
			) : (
				<UpdateEventForm
					event={eventObject as IEvent}
					visible={visible}
					setVisible={setVisible}
					refreshEvents={refreshEvents}
				/>
			)}
		</div>
	);
}

export default CompareImages;
